export const hasPermission = (permissionCode) => {
  try {
    const raw = localStorage.getItem("permissions");
    const permissions = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(permissions)) {
      console.warn("Permissions in localStorage is not an array:", permissions);
      return false;
    }
    return permissions.includes(permissionCode);
  } catch (err) {
    console.error("Error parsing permissions:", err);
    return false;
  }
};
